module.exports = __webpack_public_path__ + "static/media/workout-together.c7f31aa6.jpeg";